import React from "react"
import {
  Chip,
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material"
import { HeaderLink } from "../../../config/headerConfig"
import { useTranslationLabel } from "../../../hooks/useTranslationLabel"
import "./SideMenu.scss"
import { ExpandLess, ExpandMore, StarBorder } from "@mui/icons-material"
import InboxIcon from "@mui/icons-material/MoveToInbox"
import { LoginResponse } from "../../../types/userTypes"
import { handleLoginSuccess } from "../../../redux/slices/authSlice"

export const SideMenu = ({
  isOpen,
  onClose,
  links,
  handleLogout,
  users,
  rememberMe,
  dispatch,
  getUserAsync,
  handleLoginSuccess,
  navigate,
  routes,
  customerToken,
  languages,
  onLanguageChange,
  i18n,
}: any) => {
  const { LOGOUT, SELECT_DRIVER } = useTranslationLabel()
  const [open, setOpen] = React.useState(false)

  const handleClick = () => {
    setOpen(!open)
  }

  const renderUsers = () => {
    if (users && users.length > 0) {
      return (
        <List component="div" disablePadding>
          {users.map((user: LoginResponse, index: number) => (
            <ListItemButton
              key={index}
              selected={user.customerToken === customerToken}
              onClick={() => {
                handleLoginSuccess(user, rememberMe)
                dispatch(getUserAsync())
                  .unwrap()
                  .then(() => {
                    navigate(routes.MY_RIDES)
                  })
              }}
            >
              <ListItemText primary={user.fullMemberName} />
            </ListItemButton>
          ))}
        </List>
      )
    }
    return null
  }
  console.log("i18n ", i18n)
  return (
    isOpen && (
      <div className={`side-menu`}>
        <ul>
          {links.map((link: HeaderLink) => (
            <li key={link.path}>
              <a href={link.path} onClick={onClose}>
                {link.label}
              </a>
            </li>
          ))}
          <li onClick={handleClick} className={`side-menu-expandable`}>
            <ListItemText primary={SELECT_DRIVER} />
            {open ? <ExpandLess /> : <ExpandMore />}
          </li>
          <Collapse in={open} timeout="auto" unmountOnExit>
            {renderUsers()}
          </Collapse>
          <li>
            <Typography variant="inherit" onClick={handleLogout}>
              {LOGOUT}
            </Typography>
          </li>
          <li>
            {
              i18n.language === "en" || i18n.language === "en-US" ? (
                <Chip
                  key={'HE'}
                  label={'HE'}
                  onClick={() => onLanguageChange("he")}
                  className={`side-menu-chip`}
                />
              ) : (
                <Chip
                  key={'EN'}
                  label={'EN'}
                  onClick={() => onLanguageChange("en")}
                  className={`side-menu-chip`}
                />
              ) }

          </li>
        </ul>
      </div>
    )
  )
}
